import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import LoadMoreProductsContainer from '../../Containers/LoadMoreProductsContainer';
import LoadingDots from '../LoadingDots';
import ProductsViewGallery from './ProductsViewGallery';
import ProductsViewList from './ProductsViewList';
import ProductsViewTableGallery from './ProductsViewTableGallery';

export const LIST_TYPE_TABLE = 'table';
export const LIST_TYPE_LIST = 'list';
export const LIST_TYPE_GALLERY = 'gallery';

const ProductsView = () => {
  const {
    productsWrapper,
    listType = LIST_TYPE_GALLERY,
    isLoading,
  } = useSelector((state) => state.productsView);
  const {
    products,
    pagination,
    categorySystemId,
    brandSystemId,
    pageSystemId,
  } = productsWrapper;
  const type = brandSystemId
    ? 'brand'
    : categorySystemId
    ? 'category'
    : pageSystemId
    ? 'page'
    : 'search';

  return (
    <>
      <div
        className={`product-list product-list--category products-view--${listType}`}
      >
        {isLoading && <LoadingDots />}
        {listType == LIST_TYPE_TABLE && (
          <ProductsViewTableGallery
            products={products}
            totalHits={pagination?.totalCount}
          />
        )}
        {listType == LIST_TYPE_LIST && <ProductsViewList products={products} />}
        {listType == LIST_TYPE_GALLERY && (
          <ProductsViewGallery products={products} />
        )}
      </div>
      <div className="load-more-products">
        <LoadMoreProductsContainer
          {...pagination}
          identifier={
            type === 'brand'
              ? brandSystemId
              : type == 'category'
              ? categorySystemId
              : pageSystemId
          }
          type={type}
          products={productsWrapper}
        />
      </div>
    </>
  );
};

export default ProductsView;
